import { Box, Table, TableBody, TableCell, TableRow } from "@mui/material";
import { useState } from "react";
import { OrganisationLineItem } from "@interfaces/organisation";

interface CompanyDetailsProps {
  organisation: OrganisationLineItem;
}
export const CompanyDetails = ({ organisation }: CompanyDetailsProps) => {
  const [open, setOpen] = useState(true);

  return (
    <Box sx={{ padding: "12px" }}>
      <Table size="small" aria-label="purchases">
        <TableBody>
          <TableRow key="1">
            <TableCell>Business Name</TableCell>
            <TableCell>{organisation.organisationName}</TableCell>
          </TableRow>
          <TableRow key="2">
            <TableCell>Representative</TableCell>
            <TableCell>{organisation.representativeName}</TableCell>
          </TableRow>
          <TableRow key="3">
            <TableCell>Address</TableCell>
            <TableCell>{organisation.addressLine1}</TableCell>
          </TableRow>
          <TableRow key="3">
            <TableCell></TableCell>
            <TableCell>{`${organisation.city} ${organisation.state} ${organisation.postCode}`}</TableCell>
          </TableRow>
          <TableRow key="3">
            <TableCell>Email</TableCell>
            <TableCell>{organisation.representativeEmail}</TableCell>
          </TableRow>
          <TableRow key="3">
            <TableCell>ABN</TableCell>
            <TableCell>{organisation.abn}</TableCell>
          </TableRow>
          <TableRow key="3">
            <TableCell>Phone</TableCell>
            <TableCell>{organisation.phoneNumber}</TableCell>
          </TableRow>
          <TableRow key="3">
            <TableCell>Phone</TableCell>
            <TableCell>{organisation.phoneNumber}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
};
